
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/threads/keyword-notifications",
      function () {
        return require("private-next-pages/threads/keyword-notifications/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/threads/keyword-notifications"])
      });
    }
  